import axios from 'axios';

// Define the base API URL
const BASE_URL = process.env.REACT_APP_BACKEND_URL;

// Token storage
let authToken = sessionStorage.getItem('auth_token');

// Create an axios instance with proper configuration
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Helper functions for token management
const setAuthToken = (token) => {
  authToken = token;
  sessionStorage.setItem('auth_token', token);
};

const clearAuthToken = () => {
  authToken = null;
  sessionStorage.removeItem('auth_token');
};

// REQUEST INTERCEPTOR - Add Bearer token to requests
api.interceptors.request.use(
  (config) => {
    // Add Bearer token if available
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// RESPONSE INTERCEPTOR for handling auth errors
api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    
    // Handle unauthorized errors
    if (error.response?.status === 401 || 
        error.response?.data?.message === 'Unauthenticated.') {
      clearAuthToken();
      
      // Redirect to login page
      window.location.href = '/signin';
    }
    
    return Promise.reject(error);
  }
);


// Login function with Bearer token authentication
export const login = async (email, password) => {
  try {
    
    // Perform login request
    const loginResponse = await api.post('/api/login', { email, password });
    
    const { user, token, token_type } = loginResponse.data;
    
    // Store the token
    setAuthToken(token);
    
    return loginResponse.data;
  } catch (error) {
    throw error;
  }
};

// Logout function with Bearer token
export const logout = async () => {
  try {
    
    // Perform logout request (interceptor handles Bearer token)
    const logoutResponse = await api.post('/api/logout', {});
    
    // Clear auth token and storage
    clearAuthToken();
    sessionStorage.clear();
    
    return logoutResponse.data;
  } catch (error) {
    
    // Even if logout fails, clear token and storage
    clearAuthToken();
    sessionStorage.clear();
    
    throw error;
  }
};

// Export token management functions
export { setAuthToken, clearAuthToken };

export default api;